import React from "react";
import { Container, Stack } from "@mui/material";
import OfferComparisonTable from "../components/OfferComparisonTable";
import { useSupply } from "../context/SupplyContext";

export default function OfferComparisonPage() {
  const { offers } = useSupply();

  return (
    <Container sx={{ py: 4 }}>
      <Stack spacing={3}>
        <OfferComparisonTable offers={offers} />
      </Stack>
    </Container>
  );
}
